import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import List from '../groups/List'
import Create from '../groups/Create'
import { Modal, Alert } from 'antd'
// import { Button, Drawer, Divider, Alert } from 'antd'
import { getGroupByClient } from '../../actions/GroupAction'

export class Permission extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showCreateGroup: false,
      showAllGroup: false,
      disableControls: false,
      assetType: '',
      thisAsset: ''
    }
  }

  componentDidMount() {
    const { authUser, item, intl } = this.props
    this.setState({
      disableControls: (authUser.role === 'admin' || authUser.clientRole === 'admin') ? false : true,
    })

    const parents = item.parents && item.parents.length
    if (item) {
      if ((item.type === 'bunker') || (parents && parents === 1)) {
        this.setState({
          assetType: 'Bunker',
          thisAsset: intl.locale === 'es' ? 'este' : 'this'
        })
      } if (item.type === 'folder' && parents > 1) {
        this.setState({
          assetType: intl.formatMessage({ id: "subfolder" }),
          thisAsset: intl.locale === 'es' ? 'esta' : 'this'
        })
      }
      if (item.type === 'image') {
        this.setState({
          assetType: intl.formatMessage({ id: "searche_tooltip_image" }),
          thisAsset: intl.locale === 'es' ? 'esta' : 'this'
        })
      }
      if (item.type === 'document') {
        this.setState({
          assetType: intl.formatMessage({ id: "document" }),
          thisAsset: intl.locale === 'es' ? 'este' : 'this'
        })
      }
      if (item.type === 'video') {
        this.setState({
          assetType: intl.formatMessage({ id: "searche_tooltip_video" }),
          thisAsset: intl.locale === 'es' ? 'este' : 'this'
        })
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { groupsByClient, isFetching } = this.props
    if (prevProps.isFetching !== isFetching && prevProps.groupsByClient !== groupsByClient) {
      // this.setState({ showAllGroup: true }) WTF!
    }
  }

  handleShowCreateGroup = () => {
    this.setState({ showCreateGroup: true })
  }

  handleHideCreateGroup = () => {
    this.setState({ showCreateGroup: false })
  }

  handleShowAllGroup = () => {
    const { workclient } = this.props
    this.setState({
      showAllGroup: true
    }, () => this.props.getGroupByClient(workclient))
  }

  handleHideAllGroup = () => {
    this.setState({ showAllGroup: false })
  }

  render() {
    const { item, groupsByClient, intl, clientName, authUser } = this.props
    // newColor
    const { showCreateGroup, showAllGroup, assetType, thisAsset } = this.state
    // disableControls,

    if (!item) return (<div>loading</div>)

    return (
      <div>
        {/* {!disableControls && <React.Fragment><div style={{ display: 'flex', justifyContent: 'flex-start' }}>
          <Button
            type="default"
            style={{ color: newColor, borderColor: newColor, marginLeft: '5px' }}
            onClick={this.handleShowAllGroup}
          >{intl.formatMessage({ id: "all_the_groups" })}</Button>
          &emsp;
          <Button
            type="primary"
            style={{ backgroundColor: newColor, borderColor: newColor }}
            onClick={this.handleShowCreateGroup}
            disabled={disableControls}
          >{intl.formatMessage({ id: "new_group_button" })}</Button>
        </div>
          <Divider />
        </React.Fragment>} */}
        <Modal
          title={intl.formatMessage({ id: "group_creation" })}
          width={'95%'}
          closable={true}
          destroyOnClose={true}
          footer={null}
          onCancel={this.handleHideCreateGroup}
          onClose={this.handleHideCreateGroup}
          visible={showCreateGroup}>
          {showCreateGroup && <Create handleClose={this.handleHideCreateGroup} />}
        </Modal>
        <Modal
          title={`${intl.formatMessage({ id: "all_the_groups" })} ${intl.locale === 'es' ? 'en' : 'in'}: ${clientName.name}`}
          width={'95%'}
          closable={true}
          destroyOnClose={true}
          onCancel={this.handleHideAllGroup}
          onClose={this.handleHideAllGroup}
          footer={null}
          visible={showAllGroup}>
          {showAllGroup && <List
            from={`Permissions-showallGroup`}
            data={groupsByClient}
            isRemovable={true}
            isSelectable={true}
            dataSelected={item && item.group}
            handleClose={this.handleHideAllGroup}
            allTheGroups={true} />}
        </Modal>
        <Alert
          message={item && `${intl.formatMessage({ id: "groups_which_belongs" })} ${thisAsset} ${assetType}: ${item.name}`}
          type="info"
          style={{ marginBottom: 10 }} />
        {authUser.clientRole === 'admin' || authUser.role === 'admin'
          ? <List
            from={`Permissions-rol-admin`}
            data={item && item.objectGroups}
            isSelectable={true}
            dataSelected={item && item.objectGroups} />
          : <List
            from={`Permissions-rol-operador`}
            data={item && item.group}
            isSelectable={true}
            dataSelected={item && item.group} />}
      </div >
    )
  }
}

const mapStateToProps = state => {
  return {
    authUser: state.authUser.user,
    item: state.permission.item,
    workclient: state.client.workclient,
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
    isFetching: state.group.byClientIsFetching,
    groupsByClient: state.group.byClientData,
    clientName: state.client.data
  }
}

const mapDispatchToProps = {
  getGroupByClient,
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Permission)))
